var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLanguageFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.643 9.27.992 2.48H5.651z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 7.67c0-3.54 2.28-5.92 5.67-5.92H8.5c.552 0 1.082.438 1.208.976.111.478.262 1.111.442 1.861.864 3.622 2.376 9.95 3.162 14.515a.984.984 0 0 1-.978 1.148H6.67C3.28 20.25 1 17.87 1 14.341zm9.34 6.802-3-7.5a.75.75 0 0 0-1.393 0l-3 7.5a.75.75 0 0 0 1.393.556l.711-1.778h3.184l.712 1.778a.75.75 0 0 0 1.393-.556",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.997 16.341c0 3.529-2.27 5.909-5.66 5.909h-.982c-.494 0-.912-.357-.994-.844-.29-1.72-.69-3.716-1.124-5.733q.345-.235.666-.503a8.4 8.4 0 0 0 2.76 1.534.75.75 0 0 0 .737-1.28.8.8 0 0 0-.262-.14 6.9 6.9 0 0 1-2.17-1.18 9.4 9.4 0 0 0 1.772-3.356h.91a.75.75 0 0 0 0-1.5h-2.998V8.5a.75.75 0 1 0-1.499 0v.75H12.78c-.231-.982-.447-1.884-.632-2.66-.18-.75-.33-1.385-.442-1.863-.126-.538.24-.976.792-.976h4.84c3.39 0 5.66 2.38 5.66 5.92z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.17 10.748a7.8 7.8 0 0 1-1.267 2.299 7.8 7.8 0 0 1-1.267-2.3z"
})));
export default SvgIcLanguageFill;